// extracted by mini-css-extract-plugin
export default {"headerCell":"ChildrenTable_headerCell__+G8mH"};